let audioCtx = null;

export const unlockAudio = () => {
  try {
    if (!audioCtx) {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (audioCtx.state === 'suspended') {
      void audioCtx.resume();
    }
  } catch (_) { /* ignore */ }
};

if (typeof document !== 'undefined') {
  const once = () => {
    unlockAudio();
    document.removeEventListener('touchstart', once);
    document.removeEventListener('click', once);
  };
  document.addEventListener('touchstart', once, { passive: true });
  document.addEventListener('click', once);
}

export const playAlertSound = () => {
  try {
    unlockAudio();
    if (!audioCtx) return;
    const beep = (freq, start, duration) => {
      const o = audioCtx.createOscillator();
      const g = audioCtx.createGain();
      o.connect(g);
      g.connect(audioCtx.destination);
      o.frequency.value = freq;
      o.type = 'sine';
      g.gain.setValueAtTime(0, audioCtx.currentTime + start);
      g.gain.linearRampToValueAtTime(0.5, audioCtx.currentTime + start + 0.02);
      g.gain.linearRampToValueAtTime(0, audioCtx.currentTime + start + duration);
      o.start(audioCtx.currentTime + start);
      o.stop(audioCtx.currentTime + start + duration + 0.05);
    };
    beep(880, 0, 0.15);
    beep(880, 0.2, 0.15);
    beep(1100, 0.4, 0.3);
  } catch (_) { /* autoplay blocked */ }
};
